exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumbnail-container{display:flex;justify-content:center;margin-top:10px}.thumbnail{margin:0 5px;cursor:pointer}.thumbnail img{width:100px;height:75px;-o-object-fit:cover;object-fit:cover;border:1px solid #ccc}.thumbnail.active img{border-color:#00f}", ""]);

// exports
